"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.NumberFieldType = void 0;
const range_1 = __importDefault(require("lodash-es/range"));
const types_1 = require("@smartsuite/types");
const clipboard_1 = require("../../utils/clipboard");
const google_sheet_1 = require("../../utils/google-sheet");
const intl_1 = require("../../locale/intl");
const number_fieldtype_1 = require("../../safe-field-value/numder-fields/number-field/number.fieldtype");
const texts_1 = require("../../texts");
const number_1 = require("../../utils/number");
const base_number_fieldtype_1 = require("../base-fields/base-number.fieldtype");
const number_slider_migrations_1 = require("../number-slider-field/number-slider.migrations");
const migrations_1 = require("../../migrations/migrations");
const number_2 = require("../../formatters/number");
const detailed_decimal_1 = require("../../formatters/detailed-decimal");
class NumberFieldType extends base_number_fieldtype_1.BaseNumberFieldLogic {
    constructor() {
        super(...arguments);
        this.name = "numberfield";
        this.label = (0, intl_1.$t)(texts_1.numberFieldText.number);
        this.icon = "number";
        this.iconColor = "#EC506E";
        this.placeholder = (0, intl_1.$t)(texts_1.numberFieldText.enter_number_here);
        this.searchSynonyms = [
            (0, intl_1.$t)(texts_1.numberFieldText.integer),
            (0, intl_1.$t)(texts_1.numberFieldText.decimal),
            "1",
        ];
        this.isNumber = true;
        this.fieldValueGetter = new number_fieldtype_1.NumberFieldValueGetter();
        this.clipboardPasteRules = {
            numberfield: clipboard_1.clipboardNumberToNumber,
            currencyfield: clipboard_1.clipboardNumberToNumber,
            percentfield: clipboard_1.clipboardNumberToNumber,
            ratingfield: clipboard_1.clipboardNumberToNumber,
            autonumberfield: clipboard_1.clipboardNumberToNumber,
            rollupfield: clipboard_1.clipboardTextToNumber,
            votefield: clipboard_1.clipboardTextToNumber,
            countfield: clipboard_1.clipboardCountToNumber,
            numbersliderfield: clipboard_1.clipboardNumberToNumber,
            percentcompletefield: clipboard_1.clipboardNumberToNumber,
            unknownfield: clipboard_1.clipboardTextToNumber,
            textfield: clipboard_1.clipboardTextToNumber,
            recordtitlefield: clipboard_1.clipboardTextToNumber,
            richtextareafield: clipboard_1.clipboardTextToNumber,
            textareafield: clipboard_1.clipboardTextToNumber,
        };
    }
    isValueEmpty(fieldValue, _field) {
        return fieldValue === null || fieldValue === undefined;
    }
    valueToString(fieldValue, field, userPreferences) {
        var _a;
        if (this.isValueEmpty(fieldValue, field)) {
            return "";
        }
        return (0, number_2.convertNumberFieldValueToString)({
            value: fieldValue,
            locale: (_a = userPreferences === null || userPreferences === void 0 ? void 0 : userPreferences.locale) === null || _a === void 0 ? void 0 : _a.value,
            params: field.params,
        });
    }
    getAggregateDisplayValue(fieldValue, field, userPreferences) {
        var _a;
        if (this.isValueEmpty(fieldValue, field)) {
            return "";
        }
        return (0, number_2.convertNumberFieldValueToString)({
            value: fieldValue,
            locale: (_a = userPreferences === null || userPreferences === void 0 ? void 0 : userPreferences.locale) === null || _a === void 0 ? void 0 : _a.value,
            params: { ...field.params, include_labels: false },
        });
    }
    valueToGoogleSheet(fieldValue, field, _userPreferences) {
        var _a, _b;
        if (this.isValueEmpty(fieldValue, field)) {
            return field.params.include_labels
                ? (0, google_sheet_1.makeRowDataValues)("", "stringValue")
                : (0, google_sheet_1.makeRowDataValues)(null, "numberValue");
        }
        if (field.params.include_labels) {
            return (0, google_sheet_1.makeRowDataValues)((0, detailed_decimal_1.addLabels)(String(fieldValue), (_a = field.params.prefix) !== null && _a !== void 0 ? _a : "", (_b = field.params.suffix) !== null && _b !== void 0 ? _b : ""), "stringValue");
        }
        if (field.params.precision) {
            const pattern = (0, range_1.default)(field.params.precision).reduce((result) => {
                result += "0";
                return result;
            }, "#.");
            return (0, google_sheet_1.makeRowDataValues)(Number(fieldValue) || 0, "numberValue", "NUMBER", pattern);
        }
        return (0, google_sheet_1.makeRowDataValues)(Number(fieldValue) || 0, "numberValue");
    }
    getInitialFieldValue(startValue, field, userPreferences) {
        if (!this.validateValue(field, startValue, true, userPreferences)) {
            return this.getEmptyValue();
        }
        if (startValue === "-") {
            return "-";
        }
        return parseFloat(startValue);
    }
    getGridColumnSettings(field) {
        return {
            ...super.getGridColumnSettings(field),
            contentAlignment: "right",
        };
    }
    valueToExcelExport(fieldValue, field, userPreferences, _record) {
        return {
            t: fieldValue ? "n" : "t",
            v: String(fieldValue !== null && fieldValue !== void 0 ? fieldValue : ""),
        };
    }
    migrateField(fieldTo, fieldFrom) {
        if (fieldFrom.field_type === "numbersliderfield") {
            return (0, number_slider_migrations_1.migrateNumberSliderToNumberField)(fieldTo, fieldFrom);
        }
        return (0, migrations_1.migrateBaseField)(fieldTo, fieldFrom);
    }
    getLinkedRecordFieldSmartWidth(_field) {
        return {
            defaultWidht: 90,
            minWidth: 45,
        };
    }
    /**
     * Checks if the values are equal.
     */
    isValueEqual(fieldValue1, fieldValue2, _field, _userPreferences) {
        return fieldValue1 === fieldValue2;
    }
    prepareValueForClipboard(fieldValue, srcField, userPreferences) {
        var _a;
        return {
            text: (0, number_2.convertNumberFieldValueToString)({
                value: fieldValue,
                locale: (_a = userPreferences === null || userPreferences === void 0 ? void 0 : userPreferences.locale) === null || _a === void 0 ? void 0 : _a.value,
                params: {
                    ...srcField.params,
                    precision: srcField.params.number_abbreviation
                        ? srcField.params.precision
                        : (0, number_1.getDecimalPlacesNum)(String(fieldValue)),
                },
            }),
            rawValue: fieldValue,
        };
    }
    filterToRecordValue(filterValue, comparison, field) {
        if (comparison !== "is_equal_to" || !(0, number_1.isNumeric)(filterValue)) {
            throw new types_1.FilterToRecordValueConversionError(field, filterValue, comparison);
        }
        const value = Number(filterValue);
        if (!field.params.allow_negative && value < 0) {
            throw new types_1.FilterToRecordValueConversionError(field, filterValue, comparison);
        }
        return value;
    }
    getDefaultValue(field, userPreferences) {
        const defaultVale = super.getDefaultValue(field, userPreferences);
        if (this.isValueEmpty(defaultVale, field)) {
            return defaultVale;
        }
        return Number(field.params.default_value);
    }
    metricWidgetValueToString(fieldValue, field, userPreferences) {
        const numberValue = Number(fieldValue);
        return this.valueToString(numberValue, field, userPreferences);
    }
}
exports.NumberFieldType = NumberFieldType;
